import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { MatPaginator, MatTableDataSource, MatSnackBar, PageEvent } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-bitacora-proactivos',
  templateUrl: './bitacora-proactivos.component.html',
  styleUrls: ['./bitacora-proactivos.component.scss']
})
export class BitacoraProactivosComponent implements OnInit {

  pageSize = 10;
  FILTER: string = null;

  estadosEntrada = [
    { value: null, label: 'Todos' },
    { value: 1, label: 'Candidato a Contactar' },
    { value: 2, label: 'Primer Contacto Enviado' },
    { value: 3, label: 'Segundo Contacto Enviado' },
    { value: 4, label: 'Tercer Contacto Enviado' },
    { value: 5, label: 'Cuarto Contacto Telefónicamente' },
    { value: 6, label: 'Cliente Acepta Visita y Agenda' },
    { value: 7, label: 'Técnico Asignado Visita en Curso' },
    { value: 8, label: 'Cerrado' },
    { value: 9, label: 'Cliente No Acepta Visita' }
  ];

  grupoValBitacora = new FormGroup({
    filtro: new FormControl(''),
    telefono: new FormControl(''),
    cuenta: new FormControl(''),
    falla: new FormControl(''),
    estado_entrada: new FormControl(null)
  });

  reporteColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);
  resultsLength: number = 0;

  @ViewChild('bitacoraPaginator') bitacoraPaginator: MatPaginator;
  @ViewChild('bitacoraTable') bitacoraTable: any;

  constructor(
    public pageTitle: ComponentPageTitle,
    private gateway: GatewayService,
    private spinner: NgxSpinnerService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.pageTitle.title = 'Bitácora de Proactivos';
    this.getBitacora(0);
  }

  trackByColumn(index: number, column: string): string {
    return column;
  }

  getDisplayedColumns(): string[] {
    return ['TELEFONO', ...this.reporteColumns];
  }

  formatColumnName(column: string): string {
    return column.replace(/_/g, ' ').toUpperCase();
  }

  public isDateColumn(column: string): boolean {
    const dateKeywords = ['fecha', 'date', 'inicio', 'fin', 'final', 'cleared'];
    const excludeKeywords = ['notification_count', 'count', 'time', 'tiempo'];
    const columnLower = column.toLowerCase();

    if (excludeKeywords.some(keyword => columnLower.includes(keyword))) {
      return false;
    }

    return dateKeywords.some(keyword => columnLower.includes(keyword));
  }

  public isTimeOnlyValue(value: any): boolean {
    if (!value) return false;
    if (typeof value === 'string') {
      const timeOnlyPattern = /^\d{1,2}:\d{2}(:\d{2})?$/;
      return timeOnlyPattern.test(value.trim());
    }
    return false;
  }

  public cambioElementosBitacora(event?: PageEvent) {
    this.getBitacora(event.pageIndex);
  }

  generarBitacora() {
    if (this.bitacoraPaginator) {
      this.bitacoraPaginator.firstPage();
    }
    this.getBitacora(0);
  }

  getBitacora(page) {
    if (page == 0) {
      if (this.bitacoraPaginator) {
        this.bitacoraPaginator.firstPage();
      }
    }

    let estadoEntradaSeleccionado = this.grupoValBitacora.controls.estado_entrada.value;
    let estadoEntradaNumero = estadoEntradaSeleccionado
      ? (Array.isArray(estadoEntradaSeleccionado) ? estadoEntradaSeleccionado[0] : estadoEntradaSeleccionado)
      : null;

    let params: any = {
      page: page,
      pageSize: this.pageSize,
      sortBy: "Cuenta",
      sortOrder: "DESC"
    };

    if (estadoEntradaNumero !== null) {
      params.estado_entrada = estadoEntradaNumero;
    }

    let telefono = this.grupoValBitacora.controls.telefono.value;
    let cuenta = this.grupoValBitacora.controls.cuenta.value;
    let falla = this.grupoValBitacora.controls.falla.value;
    let nombre = this.FILTER || this.grupoValBitacora.controls.filtro.value;

    if (telefono) params.telefono = telefono;
    if (cuenta) params.cuenta = cuenta;
    if (falla) params.falla = falla;
    if (nombre) params.nombre = nombre;

    this.spinner.show();

    this.gateway.get('listarBitacoraProactivos', params).then((result: any) => {
      let registros = result.rows || [];

      if (!registros || registros.length === 0) {
        this.dataSource = new MatTableDataSource([]);
        this.resultsLength = 0;
        this.gateway.get('contarBitacoraProactivos', params).then((result: any) => {
          this.resultsLength = result.rows[0].total;
          this.spinner.hide();
        }).catch((e) => {
          this.spinner.hide();
        });
        return;
      }

      if (this.reporteColumns.length === 0 && registros.length > 0) {
        let columnas = Object.keys(registros[0]);
        columnas = columnas.filter(key =>
          !['TELEFONO', 'Telefono', 'telefono', 'acct_contact_phone1', 'ACCT_CONTACT_PHONE1', 'phone', 'PHONE', 'phone1', 'PHONE1', 'idcliente', 'IDCLIENTE', 'IdCliente'].includes(key)
        );
        this.reporteColumns = [...columnas];
      }

      this.dataSource = new MatTableDataSource(registros);
      this.cdr.detectChanges();

      setTimeout(() => {
        if (this.bitacoraTable) {
          this.bitacoraTable.updateStickyColumnStyles();
        }
        this.cdr.detectChanges();
      }, 100);

      this.gateway.get('contarBitacoraProactivos', params).then((result: any) => {
        this.resultsLength = result.rows[0].total;
        this.spinner.hide();
      }).catch((e) => {
        this.spinner.hide();
      });
    }).catch((e) => {
      this.spinner.hide();
      this.snackbar.open('Error al cargar la Bitácora de Proactivos.', 'Cerrar', { duration: 3000 });
    });
  }

  applyBitacoraFilter() {
    this.FILTER = this.grupoValBitacora.controls.filtro.value || '';
    if (this.bitacoraPaginator) {
      this.bitacoraPaginator.firstPage();
    }
    this.getBitacora(0);
  }
}
